import { render, staticRenderFns } from "./actor.vue?vue&type=template&id=87984d14&scoped=true&"
import script from "./actor.vue?vue&type=script&lang=js&"
export * from "./actor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87984d14",
  null
  
)

export default component.exports